import { useContext } from "react";
import { ScreenMax } from "styles/antTheme/Variables";
import { useMediaQuery } from "usehooks-ts";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

/**
 * Whether a web Specifications surface renders the grouped card list instead of its grid or Book: spec
 * groups on and a viewport at or below `ScreenMax.md` (991px, so tablets and narrow windows too, not
 * only phones). Between 768px and 991px the detail panel opens beside the list instead of full width.
 * It covers every audience (builders, subs, owners, and anonymous share-link viewers), so it does not
 * look at who the user is.
 *
 * Like Tasks, it follows the viewport live, so resizing or rotating across the breakpoint swaps the grid
 * and the card list. Each view owns its own panel state, so a swap closes an open spec.
 */
export function useShowSpecificationCardView(): boolean {
    const builderInfo = useContext(BuilderInfoContext);
    const isMobileWidth = useMediaQuery(`(max-width: ${ScreenMax.md}px)`);

    return isMobileWidth && builderInfo?.flags.specificationGroups === true;
}
